import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialTable from "material-table";
import ContentLoader from "react-content-loader";

import Helper from "../Helper";
import GlobalSearchService from "../services/helper/globalSearchService";
import { getTrans as t } from "../Localization/translations";

function Searchshow({ customerPermission }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss && permissionss.split(",");
  const { state } = useLocation();

  const handleSearch = () => {
    setLoading(true);
    GlobalSearchService.globalSearch(state).then((response) => {
      if (response.data.success) {
        setItems(response.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    handleSearch();
  }, [state]);

  // Party//
  let navigate = useNavigate();

  const handleView_party = (id) => {
    navigate("/party/details", { state: id });
  };

  const handleView = (id, status, contract_type) => {
    if (status === "Active" || status === "PaidOff") {
      navigate("/contract/view", { state: id });
    } else if (status === "Terminated") {
      navigate("/contract/view", { state: id });
    } else {
      if (contract_type === "Loan") {
        navigate("/editloancontract", { state: id });
      } else if (contract_type === "Rental") {
        navigate("/editrentalcontract", { state: id });
      } else if (contract_type === "Line of Credit") {
        navigate("/edit-line-of-credit-contract", { state: id });
      } else {
        navigate("/contract/edit", { state: id });
      }
    }
  };

  const handleinventoryView = (id) => {
    navigate("/itemmasterview", { state: id });
  };

  const handleView_billing = (id, status) => {
    if (status === "Saved" || status === "Completed") {
      navigate("/billing/viewinvoices", { state: id });
    } else {
      navigate("/billing/editinvoices", { state: id });
    }
  };

  const handleAssetView = (
    contract_id,
    conractstatus,
    contracttype,
    asset_id
  ) => {
    if (conractstatus === "Active" || conractstatus === "PaidOff") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else if (conractstatus === "Terminated") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else {
      if (contracttype === "Loan") {
        navigate(`/editloancontract?Asset=${asset_id}`, { state: contract_id });
      } else if (contracttype === "Rental") {
        navigate(`/editrentalcontract?Asset=${asset_id}`, {
          state: contract_id,
        });
      } else if (contracttype === "Line of Credit") {
        navigate(`/edit-line-of-credit-contract?Asset=${asset_id}`, {
          state: contract_id,
        });
      } else {
        navigate(`/contract/edit?Asset=${asset_id}`, { state: contract_id });
      }
    }
  };
  const handleEdit = (id) => {
    navigate("/itemmasteredit", { state: id });
  };

  return (
    <>
      {loading === false ? (
        <div className="content container-fluid pt-3">
          {customerPermission !== "Customer" && (
            <div className="card py-2 mb-2 ">
              <div className="card-header pb-0">
                <div>
                  <h5 className="mb-0 tc">{t("Party")}</h5>
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-md-12">
                    <div className="p-0">
                      <MaterialTable
                        style={{
                          padding: "0.5rem 0.5rem",
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        onRowClick={(event, rowData) => {
                          handleView_party(rowData.id);
                        }}
                        columns={[
                          {
                            title: `${t("Party Name")}`,
                            field: "customer_name",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Party Name")}
                                </div>{" "}
                                <div className="hyperlink">
                                  {rowData.customer_name}
                                </div>
                              </>
                            ),
                          },
                          {
                            title: `${t("Party Type")}`,
                            field: "party_type",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Party Type")}
                                </div>{" "}
                                <div className="hyperlink">
                                  {rowData.party_type}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Entity Type")}`,
                            field: "customer_type",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Entity Type")}
                                </div>{" "}
                                <div>{rowData.customer_type}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={
                          permissionss &&
                          permissionsArray.includes("view_party") === true
                            ? items.party
                            : []
                        }
                        localization={{
                          toolbar: {
                            searchPlaceholder: "Search Party",
                          },
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#008DC1",
                            fontSize: 11,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "white" };
                            } else {
                              return { backgroundColor: "#f1f4f7" };
                            }
                          },
                          sorting: true,
                          showTitle: false,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [10, 15, 20, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          exportAllData: true,
                          exportButton: false,
                          exportFileName: "Parties",
                          actionsColumnIndex: -1,
                          isLoading: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="card py-2 mb-2">
            <div className="card-header pb-0">
              <div className="d-lg-flex">
                <div>
                  <h5 className="mb-0   tc">{t("Contracts")}</h5>
                </div>
                <div className="ms-auto my-auto mt-lg-0 mt-4"></div>
              </div>
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-md-12 filter_contract">
                  <div className="table-responsive p-0">
                    <MaterialTable
                      style={{
                        padding: "0.5rem 0.5rem",
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow:
                          "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      columns={[
                        {
                          title: `${t("Contract Number")}`,
                          field: "contract_number",
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Contract Number")}
                              </div>{" "}
                              <div
                                className="hyperlink"
                                onClick={() =>
                                  rowData.status === "Entered"
                                    ? permissionss &&
                                      permissionsArray.includes(
                                        "change_contract"
                                      ) === true &&
                                      handleView(
                                        rowData.id,
                                        rowData.status,
                                        rowData.contract_type
                                      )
                                    : permissionss &&
                                      permissionsArray.includes(
                                        "view_contract"
                                      ) === true &&
                                      handleView(
                                        rowData.id,
                                        rowData.status,
                                        rowData.contract_type
                                      )
                                }
                              >
                                {rowData.contract_number}
                              </div>
                            </>
                          ),
                        },
                        {
                          title: `${t("Customer")}`,
                          field: "customer_name",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Customer")}
                              </div>{" "}
                              <div className="">{rowData.customer_name}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Start Date")}`,
                          field: "start_date",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Start Date")}
                              </div>
                              <div>{Helper.DateNormal(rowData.start_date)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Term")}`,
                          field: "contract_term",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Term")}
                              </div>
                              <div>{rowData.contract_term}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("End Date")}`,
                          field: "end_date",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("End Date")}
                              </div>{" "}
                              <div>{Helper.DateNormal(rowData.end_date)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Financed Amount")}`,
                          field: "financed_amount",
                          render: (rowData) => (
                            <>
                              <div
                                className={`d-xl-none tc d-md-none d-lg-none`}
                                style={{
                                  textAlign: rowData.isSmallScreen
                                    ? "left"
                                    : "right",
                                  fontSize: "12px",
                                  fontWeight: rowData.isSmallScreen
                                    ? "bold"
                                    : "",
                                }}
                              >
                                {t("Financed Amount")}
                              </div>
                              <div
                                className={`d-none d-xl-block d-lg-block text-right`}
                                style={{ textAlign: "right", fontSize: "12px" }}
                              >
                                {Helper.Amount(rowData.financed_amount)}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12
                          // }
                        },
                        {
                          title: `${t("Status")}`,
                          field: "status",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Status")}
                              </div>{" "}
                              <div
                                className={
                                  rowData.status === "Active"
                                    ? "badge bg-gradient-success text-xxs"
                                    : "badge badge-sm bg-gradient-secondary"
                                }
                              >
                                {rowData.status}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                      ]}
                      data={
                        permissionss &&
                        permissionsArray.includes("view_contract") === true
                          ? items.contract
                          : []
                      }
                      localization={{
                        toolbar: {
                          searchPlaceholder: "Search Party",
                        },
                      }}
                      options={{
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 12,
                        },
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: "white" };
                          } else {
                            return { backgroundColor: "#f1f4f7" };
                          }
                        },
                        sorting: true,
                        search: false,
                        toolbar: false,
                        paging: true,
                        pageSize: 10, // make initial page size
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                        pageSizeOptions: [10, 20, 25, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -1,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card py-2 mb-2">
            <div className="card-header pb-0">
              <div>
                <h5 className="mb-0 tc">{t("Invoices")}</h5>
              </div>
              <div className="ms-auto my-auto mt-lg-0 mt-4">
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-md-12 filter_invoice">
                    <div className="table-responsive">
                      <MaterialTable
                        style={{
                          padding: "0.1rem 0.1rem",
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        onRowClick={(event, rowData) => {
                          handleView_billing(
                            rowData.id,
                            rowData.invoice_status
                          );
                        }}
                        columns={[
                          {
                            title: `${t("Invoice Number")}`,
                            field: "invoice_number",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Invoice Number")}
                                </div>
                                <div className="hyperlink">
                                  {rowData.invoice_number}
                                </div>
                              </>
                            ),
                          },

                          {
                            title: `${t("Transaction Date")}`,
                            field: "creation_date",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Transaction Date")}
                                </div>
                                <div>
                                  {Helper.DateNormal(rowData.creation_date)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Due Date")}`,
                            field: "due_date",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Due Date")}
                                </div>
                                <div>{Helper.DateNormal(rowData.due_date)}</div>
                              </>
                            ),

                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Invoice Amount")}`,
                            field: "total_amount",
                            render: (rowData) => (
                              <>
                                <div
                                  className={`d-xl-none tc d-md-none d-lg-none`}
                                  style={{
                                    textAlign: rowData.isSmallScreen
                                      ? "left"
                                      : "right",
                                    fontSize: "12px",
                                    fontWeight: rowData.isSmallScreen
                                      ? "bold"
                                      : "",
                                  }}
                                >
                                  {t("Invoice Amount")}
                                </div>
                                <div
                                  className={`d-none d-xl-block d-lg-block text-right`}
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                  }}
                                >
                                  {Helper.Amount(rowData.total_amount)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12
                            // }
                          },

                          {
                            title: `${t("Remaining Amount")}`,
                            field: "balance_amount",
                            render: (rowData) => (
                              <>
                                <div
                                  className={`d-xl-none tc d-md-none d-lg-none`}
                                  style={{
                                    textAlign: rowData.isSmallScreen
                                      ? "left"
                                      : "right",
                                    fontSize: "12px",
                                    fontWeight: rowData.isSmallScreen
                                      ? "bold"
                                      : "",
                                  }}
                                >
                                  {t("Remaining Amount")}
                                </div>
                                <div
                                  className={`d-none d-xl-block d-lg-block text-right`}
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                  }}
                                >
                                  {Helper.Amount(rowData.balance_amount)}
                                </div>
                              </>
                            ),

                            headerStyle: {
                              width: 100,
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12
                            // }
                          },
                          {
                            title: `${t("Day Past Due")}`,
                            field: "install_to",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Day Past Due")}
                                </div>
                                <div>{Helper.DueDays(rowData.due_date)}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Contract No")}`,
                            field: "contract_id.contract_number",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Contract No")}
                                </div>{" "}
                                <div>{rowData.contract_id.contract_number}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Customer Name")}`,
                            field: "customer_name",
                            render: (rowData) => (
                              <>
                                {" "}
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Customer Name")}
                                </div>
                                <div>{rowData.customer_name}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={
                          permissionss &&
                          permissionsArray.includes("view_invoiceheader") ===
                            true
                            ? items.invoice
                            : []
                        }
                        options={{
                          headerStyle: {
                            backgroundColor: "White",
                            color: "#245C7F",
                            fontSize: 11,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "white" };
                            } else {
                              return { backgroundColor: "#f1f4f7" };
                            }
                          },

                          sorting: true,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 10, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [15, 20, 25, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -1,
                        }}
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card py-2 mb-2">
              <div className="card-header pb-0">
                <div>
                  <h5 className="mb-0 tc">{t("Inventory")}</h5>
                </div>
                <div className="ms-auto my-auto mt-lg-0 mt-4">
                  <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-12 filter_invoice">
                      <div className="table-responsive">
                        <MaterialTable
                          style={{
                            padding: "0.1rem 0.1rem",
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          // onRowClick={(event, rowData) => {
                          //   handleView_billing(rowData.id, rowData.invoice_status)
                          // }}

                          columns={[
                            {
                              title: `${t("Item Number")}`,
                              field: "itemname",
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Item Number")}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handleinventoryView(rowData.id)
                                    }
                                  >
                                    {rowData.itemname}
                                  </div>
                                </>
                              ),
                            },

                            {
                              title: `${t("Description")}`,
                              field: "description",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Description")}
                                  </div>
                                  <div>{rowData.description}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Serial Number")}`,
                              field: "serialnumber",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Serial Number")}
                                  </div>
                                  <div>
                                    {rowData.serialnumber
                                      ? rowData.serialnumber
                                      : ""}
                                  </div>
                                </>
                              ),

                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Model")}`,
                              field: "model",
                              render: (rowData) => (
                                <>
                                  <div
                                    className={`d-xl-none tc d-md-none d-lg-none`}
                                    style={{
                                      textAlign: rowData.isSmallScreen
                                        ? "left"
                                        : "right",
                                      fontSize: "12px",
                                      fontWeight: rowData.isSmallScreen
                                        ? "bold"
                                        : "",
                                    }}
                                  >
                                    {t("Model")}
                                  </div>
                                  <div
                                    className={`d-none d-xl-block d-lg-block text-right`}
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {rowData.model ? rowData.model : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              //   textAlign: "right",
                              //   fontSize: 12
                              // }
                            },

                            {
                              title: `${t("Contract Number")}`,
                              field: "contract_number",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Contract Number")}{" "}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handleView(
                                        rowData.contract_id,
                                        rowData.conractstatus,
                                        rowData.contracttype
                                      )
                                    }
                                  >
                                    {rowData.contract_number
                                      ? rowData.contract_number
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Asset Number")}`,
                              field: "asset_number",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Asset Number")}{" "}
                                  </div>
                                  <div
                                    className="hyperlink"
                                    onClick={() =>
                                      handleAssetView(
                                        rowData.contract_id,
                                        rowData.conractstatus,
                                        rowData.contracttype,
                                        rowData.asset_id
                                      )
                                    }
                                  >
                                    {rowData.asset_number
                                      ? rowData.asset_number
                                      : ""}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Item Type")}`,
                              field: "item_type",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Item Type")}{" "}
                                  </div>
                                  <div>
                                    {rowData.item_type
                                      ? rowData.item_type
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Status")}`,
                              field: "status",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Status")}{" "}
                                  </div>
                                  <div>
                                    {rowData.status ? rowData.status : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={
                            permissionss &&
                            permissionsArray.includes("view_invoiceheader") ===
                              true
                              ? items.itemmaster
                              : []
                          }
                          actions={[
                            (rowData) => ({
                              icon: () =>
                                permissionss &&
                                permissionsArray.includes(
                                  "change_itemmaster"
                                ) === true ? (
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/static/images/ic-edit.svg"
                                    }
                                    alt="edit"
                                  />
                                ) : (
                                  ""
                                ),
                              tooltip: "Edit",
                              onClick:
                                permissionss &&
                                permissionsArray.includes(
                                  "change_itemmaster"
                                ) === true
                                  ? (event, rowData) => {
                                      handleEdit(rowData.id);
                                    }
                                  : "",
                              // hidden: rowData.status === "Inventory" ? false : true
                            }),
                          ]}
                          options={{
                            headerStyle: {
                              backgroundColor: "White",
                              color: "#245C7F",
                              fontSize: 11,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "white" };
                              } else {
                                return { backgroundColor: "#f1f4f7" };
                              }
                            },

                            sorting: true,
                            search: false,
                            toolbar: false,
                            paging: true,
                            pageSize: 10, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [15, 20, 25, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -1,
                          }}
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentLoader
          viewBox="0 0 1000 550"
          backgroundColor="rgba(0,0,0,0.06)"
          foregroundColor="rgba(0,0,0,0.12)"
        >
          <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
          <circle cx="879" cy="123" r="11" />
          <circle cx="914" cy="123" r="11" />
          <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
          <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
          <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
          <circle cx="880" cy="184" r="11" />
          <circle cx="915" cy="184" r="11" />
          <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
          <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
          <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
          <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="242" r="11" />
          <circle cx="916" cy="242" r="11" />
          <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="303" r="11" />
          <circle cx="917" cy="303" r="11" />
          <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
          <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
          <circle cx="881" cy="363" r="11" />
          <circle cx="916" cy="363" r="11" />
          <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
          <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
          <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
          <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
          <circle cx="882" cy="424" r="11" />
          <circle cx="917" cy="424" r="11" />
          <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
          <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
          <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
          <circle cx="882" cy="484" r="11" />
          <circle cx="917" cy="484" r="11" />
          <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
          <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
          <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
          <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
          <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
          <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
          <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
          <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
          <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
          <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
        </ContentLoader>
      )}

      {/* </div> */}
    </>
  );
}

export default Searchshow;
